<div style="overflow:hidden;">
    <div class="my-1 py-1 text-center">
        <h5 class="border-0 mb-0 pb-0"> {{ event.title }}</h5>
        <h5 class="border-0 mb-0 pb-2"> {{ event.subtitle }}</h5>
        <div class="border-0 mb-0 pb-2" style="font-weight:700;"> {{ event.specialEvent }}</div>
        <div class="pb-2 description">
            <i class="fa fa-clock mr-1"></i>Event Starts: {{ event.dateStart | date: 'MM/dd/yyyy - h:mm a' }}
        </div>
    </div>
</div>